import React, { FC } from 'react';
import { IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import {
  DateRange,
  KingBed,
  Person,
  SentimentVeryDissatisfied,
  SentimentVerySatisfied,
} from '@mui/icons-material';
import ReviewWrapper from '../ReviewWrapper';
import DataShakeSummary from '../DataShakeSummary';

interface Props extends IReviewNewProps {}

const BookingReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const {
    username,
    userCountry,
    header,
    reviewText,
    positiveFeedback,
    negativeFeedback,
    rating,
    stayDuration,
    stayDate,
    travelerType,
    roomType,
    companyComment,
  } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      <DataShakeSummary reviewEntry={reviewEntry} />
      {stayDuration && stayDate && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <DateRange fontSize="small" />
          <Typography
            variant="caption"
            sx={{ ml: theme.spacing(1) }}
          >
            {stayDate} {stayDuration && `(${stayDuration})`}
          </Typography>
        </Box>
      )}
      {roomType && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <KingBed fontSize="small" />
          <Typography
            variant="caption"
            sx={{ ml: theme.spacing(1) }}
          >
            {roomType} {travelerType && `(${travelerType})`}
          </Typography>
        </Box>
      )}
      {header && (
        <Typography
          variant="h6"
          sx={{
            mt: theme.spacing(2),
          }}
        >
          {header}
        </Typography>
      )}
      {(positiveFeedback || negativeFeedback) && (
        <Divider
          orientation="horizontal"
          sx={{ mt: theme.spacing(2) }}
        />
      )}
      {positiveFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: theme.spacing(2),
          }}
        >
          <SentimentVerySatisfied sx={{ color: theme.palette.success.dark }} />
          <Typography
            variant="body2"
            sx={{ ml: theme.spacing(1) }}
          >
            {positiveFeedback}
          </Typography>
        </Box>
      )}
      {negativeFeedback && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: theme.spacing(2),
          }}
        >
          <SentimentVeryDissatisfied sx={{ color: theme.palette.error.dark }} />
          <Typography
            variant="body2"
            sx={{ ml: theme.spacing(1) }}
          >
            {negativeFeedback}
          </Typography>
        </Box>
      )}
    </ReviewWrapper>
  );
};

export default BookingReview;
